export const READ_ONLY_SALARY_FIELDS = new Set(['TotalAmount', 'BonusAmount']);
